import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { commonQuoteAction } from 'state/forms/actions/quote';
import type { ThunkDispatch } from 'state/state.common';
import type { WorkspaceType } from 'state/workspaces/model';

interface OwnProps {
  tabId: string;
  quoteId: string;
  workspaceType: WorkspaceType;
  className?: string;
}

interface DispatchProps {
  onTradeDone(): void;
}

export type TradeDoneProps = OwnProps & DispatchProps;

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId, quoteId, workspaceType }: OwnProps): DispatchProps => ({
  onTradeDone() {
    if (workspaceType === 'static') {
      logAnalytics.trackEvent('Primary market static', 'Trade done');
      dispatch(commonQuoteAction.quoteStale('static', tabId, quoteId, false));
    } else {
      logAnalytics.trackEvent('Primary market dynamic', 'Trade done');
      dispatch(commonQuoteAction.quoteStale('dynamic', tabId, quoteId, false));
    }
  },
});

export const connectTradeDoneButton = connect(null, mapDispatchToProps);
